"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 导出失败的 Icon
 * url: https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/1a0ea3ad-0bea-4158-aa7c-15f3f3eea89d
 * name: IcNext
 */
function IcNext() {
    return null;
}
exports.default = IcNext;
;
